import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
	action: null,
	gmx: {
	    roles: ["owner","architect","engineer","contractor","trade","craft","manufacturer","supplier","developer", "operator","realtor"],
	    apps: [
		{ id:1, name:"Owner", checked: false },
		{ id:2, name:"Preconstruction", checked: false },
		{ id:3, name:"Construction",checked: false },
		{ id:4, name:"Design", checked: false },
		{ id:5, name:"Manufacturing", checked: false },
		{ id:6, name:"Procurement", checked: false },
		{ id:7, name:"Operations", checked: false },
		{ id:8, name:"Real Estate", checked: false },
            ],
	    user: { email: null,
      		    emailCheck: "is-valid",
      		    name: null,
      		    roles: [],
      		    company: null,
      		    title: null,
      		    thoughts: null,
      		    errors: [],
      		    selected: []}
	},
  	pods: [
  	    {
        	title: 'Pod Browser',
		id: 'podBrowser',
  		price: '$10',
  		description: 'Trinity powered Solid Pod authoring & browsing.',
        	offer: 'Try free for 30 days',
        	purchase: 'or purchase now',
        	btnVariant: 'success',
		href: 'https://graphmetrix.net',
  	    },
  	    {
  		title: 'Starter Pod',
		id: 'starterPod',
  		price: '$20',
  		description: 'Trinity Pod service with advanced authoring, browsing and storage.',
        	offer: 'Coming Soon',
        	purchase: '',
        	btnVariant: 'secondary',
		href: '#',
  	    },
  	    {
  		title: 'Pro Pod',
		id: 'proPod',
  		price: '$30',
  		description: 'Enterprise-level Trinity service ideal for businesses.',
        	offer: 'Coming Soon',
        	purchase: '',
        	btnVariant: 'secondary',
		href: '#',
  	    },
   	    {
  		title: 'Pro Pod+',
		id: 'proPodPlus',
  		price: 'Contact Us',
  		description: 'Trinity Powered Enterprise collaboration and storage with Kenesto Drive.',
        	offer: 'Coming Soon',
        	purchase: '',
        	btnVariant: 'secondary',
		href: '#',
  	    },
  	],
	features: [
  	    {
        	title: 'Solid Pods',
        	features: 'Owning your own secure data pod allows you to control where it is stored, what can be shared, and who has to access it. Highly secure with agents and your information on the same system - communicating only to the central “Brain” for guidance.',
		img: "../assets/purple_plexus.png",
		learnmore: "solid",
  	    },
  	    {
        	title: 'Construction Linked Data Platform',
        	features: 'Link silos to turn internal or external disconnected BIM and data into integrated and actionable linked information. Changes tracked at property level, enable BIM visualized progress and risk reporting with IoT sensors, across all agents and systems.',
		img: "../src/assets/purple-plexus.png",
  	    },
	],
	pricingFields: [
    	    {
		feature:
		{
    		    label: '',
    		    tdClass: 'td-class-1st-column'
    		}
    	    },
    	    {
		podBrowser:
		{
		    label: '',
    		    tdClass: 'td-class'
		}
	    },
	    {
		starterPod:
		{
		    label: '',
    		    tdClass: 'td-class'
    		}
	    },
	    {
		proPod:
		{
		    label: '',
    		    tdClass: 'td-class'
    		}
	    },
	    {
		proPodPlus:
		{
		    label: '',
    		    tdClass: 'td-class'
    		}
	    }
	],
	pricingFeatures: [
	    { feature: 'Solid Pod Browsing', podBrowser: true, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Solid Security', podBrowser: true, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Solid Collaboration', podBrowser: true, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Trinity Forms', podBrowser: true, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Subdomain WebID', podBrowser: false, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Trinity Inference', podBrowser: false, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Semantic Search', podBrowser: false, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Statements', podBrowser: false, starterPod: '500,000', proPod: '2,000,000', proPodPlus: '5,000,000' },
	    { feature: 'Property level version control / state streams', podBrowser: false, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'File Storage', podBrowser: false, starterPod: '100 Gb', proPod: 'Unlimited', proPodPlus: 'Unlimited' },
	    { feature: 'Trinity PDF', podBrowser: false, starterPod: true, proPod: true, proPodPlus: true },
	    { feature: 'Windows, OS X, Linux, FreeBSD, Android, iOS File Syncing', podBrowser: false, starterPod: false, proPod: 'Coming Soon', proPodPlus: 'Coming Soon' },
	    { feature: 'Kenesto Drive', podBrowser: false, starterPod: false, proPod: false, proPodPlus: true }
	],
	topTableItems: [
	    { feature: '', podBrowser: 'COMING SOON', starterPod: '', proPod: '', proPodPlus: '' }
	],
	topTableFields: [
    	    {
		feature:
		{
    		    label: '',
    		    tdClass: 'top-table-td-class-1st-column'
    		}
    	    },
    	    {
		podBrowser:
		{
		    label: '',
    		    tdClass: 'top-table-td-class-available'
		}
	    },
	    {
		starterPod:
		{
		    label: '',
    		    tdClass: 'top-table-td-class'
    		}
	    },
	    {
		proPod:
		{
		    label: '',
    		    tdClass: 'top-table-td-class'
    		}
	    },
	    {
		proPodPlus:
		{
		    label: '',
    		    tdClass: 'top-table-td-class'
    		}
	    }
	],
	leaders: [
  	    {
  		name: "Frederick Gibson",
      		title: "Founder & CEO",
      		image: "about_fcg.png",
      		link: "https://www.linkedin.com/in/gibsonf1/",
      		email: "mailto:frederick@graphmetrix.com",
      		bio: "Construction innovator for the last 8 years on multi-billion dollar projects at Bechtel, creator of Bechtel’s iHub knowledge graph platform, principal architect at FGA+A for 14 years and former startup founder.",
      		experience: [["images/bechtel-logo-sm.jpg",
			      "Bechtel",
			      "http://www.bechtel.com/"],
			     ["images/FGAA-LOGO-6-sm.jpg",
			      "Frederick Gibson + Associates Architecture",
			      "http://gibson-design.com/home"],
			     ["images/streamfocus-cropped-sm.gif",
			      "StreamFocus",
			      "http://streamfocus.com"],
			     ["images/hok-logo-sm.png",
			      "HOK Architecture/Engineering/Planning",
			      "http://www.hok.com/"]]
	    },
	    /*{
  		name: "Mark Klusza",
      		title: "Co-Founder",
      		image: "about_mk.png",
      		link: "https://www.linkedin.com/in/klusza/",
      		email: "mailto:me@klusza.com",
      		bio: "Former Construction Strategy & Innovation lead at Autodesk, former Chief Innovation Officer at Assemble Systems, founder of DotProduct and many other startups - industry leading innovator in AEC and Plant technology.",
      		experience: [["images/Assemble-logo.png",
      			      "https://assemblesystems.com/"],
  			     ["images/dotproduct-logo.png",
	   		      "https://www.dotproduct3d.com/"]]
	    },*/
	    {
  		name: "Kai Gilb",
      		title: "Co-Founder",
      		image: "about_kg.png",
      		link: "https://no.linkedin.com/in/kaigilb",
      		email: "mailto:kai@graphmetrix.com",
      		bio: "Prior 28 years, Founder and CEO of Gilb International - product development consulting with focus on systems engineering. Select Clients: CitiBank, Qualcomm, HP, Philips Medical, UECC, Bring, BOSH, Ericsson, UnitedHealthcare, Schlumberger, 20K Engineers at Intel.",
      		experience: [[ ]]
	    },
	    {
    		name: "Roger Perry",
        	title: "Co-Founder",
        	image: "about_rp.png",
        	link: "https://www.linkedin.com/in/roger-perry-51922512",
        	email: "mailto:roger@graphmetrix.com",
        	bio: "Principal Engineer, Construction Strategy & Innovation at Autodesk, Senior Director of Construction Technologies at Assemble Systems, former Director of System Integration at CB&I, former IT Director at the Shaw Group, and former CAE/CAD Manager at Stone & Webster.",
        	experience: [[ ]]
  	    },
            {
    		name: "Lenin Mangoba",
        	title: "Technologist",
        	image: "about_lm.png",
        	link: "https://www.linkedin.com/in/lenin-mangoba-4525959a",
        	email: "mailto:len@graphmetrix.com",
        	bio: "Visualization Specialist at Bechtel for 14 years. Assisted in the development of Bechtel's iHub knowledge graph platform. Produced VR and AR pilots for Bechtel's mobile, innovation, and BIM initiatives. Produced graphics, video, animation, print, and web for all Bechtel business units.",
        	experience: [[ ]]
  	    },
	    /*{
  		name: "Anirban Ghosh",
      		title: "UX Design",
      		image: "about_ag.png",
      		link: "https://ca.linkedin.com/in/anirbanghosh2/",
      		email: "mailto:anirban.ghosh@sanna.io",
      		bio: "Managing Director of Sanna Inc. focusing on AEC, BIM/CAD industry, former UX Director at Invicara, former Principal UX Designer at Autodesk, and former digital automotive designer at GM design.",
      		experience: [[ ]]
	    },*/
	    {
  		name: "Theresa Rogers",
      		title: "Corporate Administrator",
      		image: "about_tr.png",
      		link: "https://www.linkedin.com/in/theresa-rogers-541769100/",
      		email: "mailto:theresa@graphmetrix.com",
      		bio: "Twenty years of office administration experience in the medical and higher education fields. Former Senior Production Supervisor in the manufacturing of rigid disk drives at Akashic, Western Digital and Komag. Currently performs corporate administration in day-to-day running of GraphMetrix.",
      		experience: [[ ]]
	    },
	    {
  		name: "Trinity",
      		title: "AI Agent",
      		image: "about_trinity.gif",
      		link: "https://www.linkedin.com/company/graphmetrix",
      		email: "mailto:trinity@graphmetrix.com",
      		bio: "Bringing together the power of the Linked Data Platform, AI algorithms, and a unifying Aristotelian conceptual hierarchy. She understands the problem and takes focused action to solve it.",
      		experience: [[ ]]
	    }
	],
	board: [
	    {
		name: "Tom Gilb",
      		title: "Founder of Gilb Academy",
      		image: "about_tg.png",
      		link: "https://www.linkedin.com/in/tomgilb",
      		email: "",
      		bio: "Tom joined IBM in 1958 and has spent most of his life as an independent international consultant, teacher, and methods inventor. Author of many books. In 2005 he published ‘Competitive Engineering’, defining Planguage, a systems engineering planning language that has been inspirational to Frederick Gibson’s work with Trinity and conceptual computing.",
      		experience: [[ ]]
	    },
  	    {
		name: "Joseph Levi",
      		title: "Project Manager at Pavarini McGovern",
      		image: "about_jl.png",
      		link: "https://www.linkedin.com/in/joseph-levi-a2949621/",
      		email: "",
      		bio: "Joseph Levi brings more than 20 years of experience to his role as Construction Project Manager. He currently serves as a core and shell project manager at TSX Broadway in Times Square - a new 550,000-square-foot, 48-story tower which will incorporate numerous exclusive features, including a permanent outdoor stage, 10 floors of flexible retail/experiential space, and a new 669-key lifestyle hotel. Joseph leverages his robust experience in development, implementation, and execution of programming and procedures, which has proven to generate both immediate and long-term results. His completed project experience includes mid-rise residential, commercial, industrial, high-rise hotel, federal and institutional projects. Outside of work Joseph has aided in the design and implementation of Construction Digital Twin Technology at Graphmetrix, and is a soccer dad.",
      		experience: [[ ]]
	    },
	    {
		name: "John Goecke",
		title: "CEO and President of StratusVue",
		image: "about_jg.png",
		link: "https://www.linkedin.com/in/johngoecke/",
		email: "",
		bio: "John Goecke drives StratusVue’s product development, optimizes its operations and ensures high-quality service delivery. He began developing StratusVue’s software in 2001 while he was an executive in a printing services company. John launched the software enterprise as PlansandSpecs and spun it off in 2007; he has been leading and growing the company ever since. With more than 30 years of industry experience, John understands the complexities of construction document management and what clients need to keep their projects on track.",
		experience: [[ ]]
	    },
	    /*{
		name: "Raul Gomez",
      		title: "Co-Founder & Board Chairman at Constructmetrix.com",
      		image: "about_rg_2.png",
      		link: "https://www.linkedin.com/in/raul-gomez-a68b889/",
      		email: "",
      		bio: "With over 25+ years of AEC technology integration in the US, and International. Presently serve as Engineering Manager at Gaylor Electric. With a focus on Data Center and Healthcare Construction. Incorporating BIM Management, technology strategies and leveraging vendor relationships within the AEC marketplace. Helping to maximize and evolve Model based design, analysis purposes of streamlined construction and prefabrication in directly applying BIM / VDC / VR / ROBITIC/ HD-SCAN/ DRONE/ PM-MOBILE/ FIELD-MOBILE / PROCORE/ QUANTITY EXTRACTION / PREFAB / FM and MODULAR CONSTRUCTION / LEAN and IPD practice. ",
      		experience: [[ ]]
	    },*/
	    {
		name: "Jans Aasman",
      		title: "CEO of Franz Inc.",
      		image: "about_ja.png",
      		link: "https://www.linkedin.com/pub/dir/jans/aasman",
      		email: "",
      		bio: "Jans Aasman is a Ph.D. psychologist and expert in the Cognitive Science - as well as CEO of Franz.com, an early innovator in Artificial Intelligence and provider of Semantic Graph Databases and Analytics. As both a scientist and CEO, Dr. Aasman continues to break ground in the areas of Artificial Intelligence and Semantic Databases as he works hand-in-hand with organizations such as Montefiore Medical Center, Blue Cross/Blue Shield, Siemens, Merck, Pfizer, Wells Fargo, BAE Systems as well as US and Foreign governments.",
      		experience: [[ ]]
	    },
			{
			name: "Mike Payne",
      		title: "CEO of Kenesto",
      		image: "about_mp.png",
      		link: "https://www.linkedin.com/in/michael-payne-957a691",
      		email: "",
      		bio: "CEO of Kenesto, Co-founder and former CEO of SpaceClaim Corporation, former CTO and Executive VP of Dassault Systems, Co-founder of SolidWorks, has over 30 years of experience in the software industry.",
      		experience: [[ ]]
	    },
	    /*{
		name: "Kai Gilb",
      		title: "Co-founder of Gilb Academy",
      		image: "about_kg.png",
      		link: "https://no.linkedin.com/in/kaigilb",
      		email: "",
      		bio: "Specializes in helping clients succeed in product development. Helps clients identify, specify & deliver quantified improvement results to their stakeholders. Experience from decades of practice from all over the world, both big and small. Teaches and consults the use of agile quantified engineering methods. ",
      		experience: [[ ]]
	    },
	    {
		name: "Frode Odegard",
      		title: "Founder and CEO of Post-Lean Institute",
      		image: "about_fo.png",
      		link: "https://www.linkedin.com/in/odegard",
      		email: "",
      		bio: "Chairman & CEO at Post-Lean Institute (PLI), a global research and consulting firm helping corporates and private equity firms navigate, exploit and engage in disruptive innovation.",
      		experience: [[ ]]
	    }*/
	],
	featureText: [
	    {
		title: "Own Your Information",
		description: "either on your own server or secure in the cloud – control who collaborates with your organization.",
		image: "https://via.placeholder.com/100"
	    },
	    {
		title: "Link your Silos",
		description: "to turn internal or external disconnected BIM and data into integrated and actionable linked information.",
		image: "https://via.placeholder.com/100"
	    },
	    {
		title: "Highly Secure",
		description: "with agents and your information on the same system - communicating only to the central AI for conceptual guidance.",
		image: "https://via.placeholder.com/100"
	    },
	    {
		title: "Changes tracked",
		description: "at property level, enable BIM visualized progress and risk reporting with IoT sensors, across all agents and systems.",
		image: "https://via.placeholder.com/100"
	    },
	    {
		title: "Work Processes",
		description: "iterated with real-time feedback and dynamically redeployed for continuous evolution and improvements.",
		image: "https://via.placeholder.com/100"
	    },
	    {
		title: "Agents Guide",
		description: "your team with the right information at the right time to get the work done.",
		image: "https://via.placeholder.com/100"
	    }
	],
	news: [
	    /*{
	      headline: "Turning PDF Data into Linked Actionable Information",
	      date: "Mar 6, 2019",
	      image: "/images/news_banner_pdf_parse.png",
	      thumbnail: "/images/news_thumb_pdf_parse.png",
	      blurb: "Trinity AI can turn the data in your PDFs into linked actionable information. By understanding contextual links, Trinity can connect isolated data silos.",
	      link: "blogPage20190306",
	      author: "Len Mangoba",
	      authorTitle: "Technologist",
	      authorImg: "/images/about_lm.png",
	      authorLink: "about"
	      },*/
	    {
		headline: "Introducing the Solution Stack",
		date: "Feb 14, 2019",
		image: "/images/news_banner_stack.png",
		thumbnail: "/images/news_thumb_stack.png",
		blurb: "The graphMetrix solution stack addresses the lack of productivity in the construction industry, connects disconnected silos of data, and captures the reasons for design, logistics, and construction decisions.",
		link: "blogPage20190214",
		author: "Fred Gibson",
		authorTitle: "Founder & CEO, graphMetrix",
		authorImg: "/images/about_fcg.png",
		authorLink: "about"
	    },
	    {
		headline: "Roger Perry is the new graphMetrix Director of Construction Technology",
		date: "Feb 4, 2019",
		image: "/images/news_banner_rp.png",
		thumbnail: "/images/news_thumb_rp.png",
		blurb: "Roger has decades of experience both in automation leadership roles for large Engineering, Procurement, and Construction (EPC) companies as well as in development roles for software development companies.",
		link: "blogPage20190204",
		author: "Fred Gibson",
		authorTitle: "Founder & CEO, graphMetrix",
		authorImg: "/images/about_fcg.png",
		authorLink: "about"
	    }
	],
	Meta: { "main": {"title": "graphMetrix - Construction Linked Data Toolkit",
			 "description": "We deliver just the information you need to get the job done right the first time",
			 "image": "https://graphmetrix.com/images/graphMetrix-main.png"},
		"about": {"title": "graphMetrix - About Us",
			  "description": "graphMetrix's Team and Board of Advisors",
			  "image": "https://graphmetrix.com/images/graphMetrix-about-us-2.png"},
		"pricing": {"title": "graphMetrix - Pricing",
			    "description": "graphMetrix Solid Pod Pricing",
			    "image": "https://graphmetrix.com/images/graphMetrix-pricing.png"},
		"solid": {"title": "graphMetrix - Trinity Powered Solid Pod authoring and browsing",
			  "description": "graphMetrix - Trinity Powered Solid Pod authoring and browsing - own and control your information on the decentralized web",
			  "image": "https://graphmetrix.com/images/graphMetrix-Solid.png"},
		"construction": {"title": "graphMetrix - Construction Linked Data Platform",
				 "description": "graphMetrix transforms your data silos into Solid linked actionable information that you control",
				 "image": "https://graphmetrix.com/images/graphMetrix-Construction.png"},
		"contact": {"title": "graphMetrix - Contact our team today. Thanks for your interest!",
			    "description": "We look forward to hearing from you.",
			    "image": "https://graphmetrix.com/images/graphmetrix-contact-us.png" },
		"features": {"title": "graphMetrix - Trinity Powered Construction Linked Data Platform Features",
			     "description": "graphMetrix - Trinity Powered Construction Linked Data Platform Features",
			     "image": "https://graphmetrix.com/images/graphMetrix-Construction-Linked-Data-Platform-Features.png" },
		"pdfGraphing": {"title": "graphMetrix - Trinity PDF",
				"description": "Trinity transforms your standard pdf files into Solid linkable information",
				"image": "https://graphmetrix.com/img/pdf_parsing.png"},
		"solidLDP": {"title": "graphMetrix - Solid Linked Data Platform",
			     "description": "graphMetrix transforms your data silos into Solid linked actionable information that you control",
			     "image": "https://graphmetrix.com/images/news_thumb_stack.png"},
		/*"blog": {"title": "graphMetrix Blog",
  			 "description": "graphMetrix Blog",
  			 "image": "https://graphmetrix.com/images/news_image_rp.png"},
		"blogPage20190204": {"title": "graphMetrix Blog - We are happy to announce Roger Perry as the new graphMetrix Director of Construction Technology",
   				     "description": "We are happy to announce Roger Perry as the new graphMetrix Director of Construction Technology",
   				     "image": "https://graphmetrix.com/images/news_image_rp.png"},
		"blogPage20190214": {"title": "Introducing the Solution Stack",
				     "description": "Introducing the Solution Stack",
				     "image": "https://graphmetrix.com/images/news_image_stack.png"},
		"blogPage20190306": {"title": "Turning PDF Data into Linked Actionable Information",
		  "description": "Turning PDF Data into Linked Actionable Information",
		  "image": "https://graphmetrix.com/images/news_thumb_pdf_parse.png"}
  		"survey": {"title": "graphMetrix - Current Process Evaluation Survey",
  			   "description": "Current Process Evaluation Survey",
  			   "image": "https://graphmetrix.com/images/graphMetrix-survey.png"},*/
		"privacy": {"title": "graphMetrix Privacy",
  			    "description": "graphMetrix Privacy Policy",
			    "image": "https://graphmetrix.com/images/graphMetrix-survey.png"},
		/*"support": {"title": "graphMetrix Customer Support",
  			    "description": "graphMetrix Customer Support",
  			    "image": "https://graphmetrix.com/images/graphMetrix-survey.png"},
		"Products": {"title": "graphMetrix - Trinity Toolkit",
  			     "description": "We deliver just the information you need to get the job done right the first time",
  			     "image": "https://graphmetrix.com/images/graphmetrix-trinity-links-pdfs.jpg"},
		"NewHome": {"title": "graphMetrix - Trinity Toolkit",
  			    "description": "We deliver just the information you need to get the job done right the first time",
  			    "image": "https://graphmetrix.com/images/graphmetrix-trinity-links-pdfs.jpg"},*/
		"Construction": {"title": "graphMetrix - Construction",
  				 "description": "We give you back control over your data",
  				 "image": "https://graphmetrix.com/images/graphmetrix-trinity-links-pdfs.jpg"},
		"trinapp-files": {"title": "graphMetrix - TrinApp Files",
  				  "description": "File storage built on top of TrinPods with Trinity conceptual AI",
  				  "image": "https://graphmetrix.com/img/trinapp_files.png"},
		"trinpod": {"title": "graphMetrix - TrinPod",
  				  "description": "Industrial strength Solid Pod with conceptual computing through Trinity AI Capable of handling a massive amount of data",
  			    "image": "https://graphmetrix.com/img/trinity_secure.png"},
		"property": {"title": "graphMetrix - Trinity Property",
  				     "description": "Connect all your systems, applications, and databases across all your Properties",
  				     "image": "https://graphmetrix.com/img/trinity_properties_hat.png"},
		"logistics": {"title": "graphMetrix - Trinity Logistics",
  				      "description": "Connects All your systems and gives you end to end visibility of all your data",
  				      "image": "https://graphmetrix.com/img/trinity_logistics.png"},
		"NotFound": {"title": "Not found",
  			     "description": "Not found",
  			     "image": "https://graphmetrix.com/images/404banner.png"}	
	      }
    },
    mutations: {
	login (state, action) {
	    state.login = action
	}
    },
    actions: {

    },
});
